<template>
  <div id="register-box">
    <indexHeader></indexHeader>
    <div class="reg-content flex">
      <div class="left-box">
        <div class="title whites">{{$t('register.register')}}</div>
        <div class="tab">
          <span :class="['pointer',{'active':isMb}]" @click="setIsMb(true)">{{$t('register.phoneRegister')}}</span> 
          <span :class="['pointer',{'active':!isMb}]" @click="setIsMb(false)">{{$t('register.emailRegister')}}</span>
        </div>
        <div class="step-one">
          <p class="tip">{{$t('register.country')}}</p>
          <div class="country-box bg-part">
            <div class="flex between alcenter plr20">
              <input class="pointer lf_input input_color bd bg-part" style="width:490px" type="text" v-model="areaCity" readonly @click="showCity= !showCity;showCode=false">
              <i class="iconfont icon-xiala ft12" v-if="!showCity"></i>
              <i class="iconfont icon-shangla_icon ft12" v-else></i>
            </div>
            <ul class="curPer input_select scroll bg-part" v-if="showCity">
              <li class="flex between alcenter bdb" v-for="(item,index) in country" :key="index" @click="getCity(item.name_en,item.area_code)">
                <p>{{item.name_en}}</p>
                <p class="tr">{{item.name_cn}}</p>
              </li>
            </ul>
          </div>
        </div>
        <div class="account-box ">
          <div class="tip" v-if="isMb">{{$t('register.enterPhone')}}</div>
          <div class="tip" v-if="!isMb">{{$t('register.enterEmail')}}</div>
          <div class="country-box bgtrans" v-if="isMb">
            <div class="flex">
              <div class="flex between alcenter bdr plr20 ">
                <input class="lf_input pointer input_color bd bg-part" type="text" v-model="areaCode"  readonly @click="showCode= !showCode;showCity=false">
                <i class="iconfont icon-xiala ft12" v-if="!showCode"></i>
                <i class="iconfont icon-shangla_icon ft12" v-else></i>
              </div>
              <input type="text" v-if="isMb" v-model="account" class="phone flex1 codeinput input_color bd bg-part">
            </div>
            <ul class="curPer input_select scroll bg-part" v-if="showCode">
              <li class="flex between alcenter bdb" v-for="(item,index) in country" :key="index" @click="getCode(item.area_code)">
                <p>{{item.name_en}}</p>
                <p class="tr">{{item.area_code}}</p>
              </li>
            </ul>   
          </div>
          <input type="text" v-if="!isMb" v-model="account" class="input_color bd bg-part">
        </div>
        <div class="tip" style="margin-bottom:10px">{{$t('set.enterCode')}}</div>
          <div class="code-box flex between">
            <input type="text" v-model="code" class="code input_color bd bg-part">
            <button type='button' class="code-btn curPer bg-part  input_color" @click="sendCode">{{$t('set.sendCode')}}</button>
          </div> 
          <div class="pwd-box">
            <div class="tip">{{$t('set.enterPsw')}}</div>
            <input type="password" v-model="pwd" class="pwd-input input_color bd bg-part" :placeholder="$t('register.psw16')">
          </div>
          <div class="repwd-box">
            <div class="tip">{{$t('set.enterPswagain')}}</div>
            <input type="password" v-model="repwd" class="repwd-input input_color bd bg-part" :placeholder="$t('set.enterPswagain')">
          </div>
          <div class="invite-box">
            <div class="tip">{{$t('register.inviteCode')}}</div>
            <input type="text" readonly v-if="inviteBool"  v-model="invite" class="invite-input input_color bd bg-part" :placeholder="$t('register.inviteCode')">
            <input type="text" v-if="!inviteBool"  v-model="invite" class="invite-input input_color bd bg-part" :placeholder="$t('register.inviteCode')">
          </div>
          <div class="flex alcenter ft12 mt20">
            <input type="checkbox" class="check" v-model="read" @click='readme'>
            <span class="ml5 baseColor">{{$t('register.read')}}</span>
            <router-link to="/policy" class="ml5 baseColor curPer " >{{$t('register.xieyi')}}</router-link>
          </div>
          <button type="button" @click="register" class="reg-btn confirm-btn curPer radius4">{{$t('register.register')}}</button>
        </div>
        <div class="right-box">
          <div class="right-tip ft12">
            <p>{{$t('register.tips01')}}</p>
            <p>{{$t('register.tips02')}}</p>
            <p>{{$t('register.tips03')}}</p>
            <p>{{$t('register.tips04')}}</p>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import country from '../lib/country.js'
import indexHeader from "@/view/indexHeader";
export default {
  components: {
    indexHeader
  },
  data() {
    return {
      isMb: true,
      account: "",
      pwd: "",
      repwd: "",
      code: "",
      invite: "",
      inviteBool:false,
      read:true,
      timer: "",
      country:country,
      areaCity:country[0].name_en,
      areaCode:country[0].area_code,
      showCity:false,
      showCode:false
    };
  },
  created() {
    var invite=this.get_all_params().extension_code;
    if(invite){
      this.inviteBool=true;
      this.invite=invite;
    }
    var emreg = /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
    var haccount = this.$route.query.haccount;
    if(haccount){
      this.account=haccount;
      if(emreg.test(haccount)){
        this.isMb=false;
      }
    }
  },
  methods: {
    get_all_params() {
      var url = location.href;
      var paraString = url.substring(url.indexOf("?") + 1, url.length).split("&");
      var paraObj = {};
      for (var i = 0; i < paraString.length; i++) {
          var nameValue = paraString[i];
          var name = nameValue.substring(0, nameValue.indexOf("=")).toLowerCase();
          var value = nameValue.substring(nameValue.indexOf("=") + 1);
          if (value.indexOf("#") > -1) {
              value = value.split("#")[0];
          }
          paraObj[name] = decodeURI(value);
      }
      return paraObj;
    },
    getCode(code){
      this.areaCode=code;
      this.showCode=false;
    },
    getCity(city,code){
      this.areaCity=city;
      this.areaCode=code;
      this.showCity=false;
    },
    setIsMb(boo) {
      this.account = "";
      this.pwd = "";
      this.repwd = "";
      this.code = "";
      this.isMb = boo;
      clearInterval(this.timer);
      var codeBtn = document.querySelector(".code-btn");
      codeBtn.disabled = false;
      codeBtn.innerHTML = this.$t('set.sendCode');
    },
    sendCode(e) {
      let that = this;
      let isMb = this.isMb;
      let url = "sms_send";

      if (this.account == "") {
        layer.msg(this.$t('set.enterAccount'));
        return;
      }
      if (e.target.disabled) return;

      // 手机号校验：纯数字 + 大于6位
      if (isMb) {
        let numReg = /^\d+$/;
        if (!numReg.test(this.account) || this.account.length <= 6) {
          layer.msg("手机号必须为纯数字且长度大于6位");
          return;
        }
      } else {
        var emreg = /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
        if (!emreg.test(this.account)) {
          layer.msg(this.$t('register.emailFalse'));
          return;
        }
        url = "sms_mail";
      }

      let data = { 
        user_string: this.account,
        area_code: this.areaCode.substr(this.areaCode.indexOf("+")+1),
        scene: 'register'
      };
      data.area_code_id = this.areaCode=="+86" ? 1 : 0;
      
      let loa = layer.load();
      this.$ajax({
        url: "/api/" + url,
        method: "post",
        data: data
      }).then(res => {
        layer.close(loa);
        layer.msg(res.data.message);
        if(res.data.type=='ok'){
          var time = 60;
          this.timer = setInterval(function() {
            e.target.innerHTML = time + "s";
            e.target.disabled = true;
            if (time == 0) {
              clearInterval(that.timer);
              e.target.innerHTML = that.$t('set.sendCode');
              e.target.disabled = false;
              return;
            }
            time--;
          }, 1000);
        }else{
          e.target.disabled = false;
        }
      });
    },
    readme(){
      this.read=!this.read;
    },
    register() {
      // 前端校验
      if(this.invite==''){
         layer.msg(this.$t('register.inviteCode')+this.$t('register.sel'));return;
      }
      if(this.account == ''){
        layer.msg(this.$t('set.enterAccount'));return;
      }
      
      // 注册时也校验手机号规则
      if(this.isMb){
        let numReg = /^\d+$/;
        if (!numReg.test(this.account) || this.account.length <= 6) {
          layer.msg("手机号必须为纯数字且长度大于6位");
          return;
        }
      }

      if(this.code == ""){
        layer.msg(this.$t('set.enterCode'));return;
      }
      if(this.pwd == ""){
        layer.msg(this.$t('set.enterPsw'));return;
      }
      if(this.pwd.length <6 || this.pwd.length >16){
        layer.msg(this.$t('register.psw16'));return;
      }
      if(this.repwd == ""){
        layer.msg(this.$t('set.enterPswagain'));return;
      }
      if(this.pwd !== this.repwd){
        layer.msg(this.$t('set.pswFalse'));return;
      }
      if(!this.read){
        layer.msg("请同意用户协议");
        return;
      }

      var data = {
        type: this.isMb ? "mobile" : "email",
        user_string: this.account,
        code: this.code,
        password: this.pwd,
        re_password: this.repwd,
        extension_code: this.invite,
        area_code: this.areaCode.substr(this.areaCode.indexOf("+")+1),
        area_code_id: this.areaCode=="+86" ? 1 : 0,
        nationality: this.areaCity
      };

      var loa = layer.load();
      this.$ajax({
        url: "/api/user/register",
        data: data,
        method: "post"
      }).then(res => {
        layer.close(loa);
        if (res.data.type == "ok") {
          this.$router.push("/components/login?isEmail="+!this.isMb);
        }else{
          layer.msg(res.data.message);
        }
      });
    }
  }
};
</script>

<style lang='scss'>
#register-box {
  .tip {
    margin: 10px 0;
    color: #61688a;
    font-size: 12px;
  }
  .reg-content {
    padding: 100px 0 100px 100px;
    display: flex;
    .left-box{
      width: 525px;
      > div > div{
        margin: 10px 0 15px;
      }
      color: #c7cce6;
      input,.country-box {
        width: 520px;
        height: 46px;
        border-radius:0;
        padding: 0 20px;
        font-size: 14px;
        background-color: #1e2235;
        position: relative;
        span{
          min-width: 80px;
        }
        .lf_input{
          width: 80px;
          border: none;
          height: 46px;
          border-radius: 0;
          padding: 0;
        }
      }
      .country-box{
        padding: 0;
        .plr20{
          padding-left: 10px;
          padding-right: 10px;
        }
      }
      .codeinput{
        border: none;
        height: 46px;
      }
      .input_select{
        width: 100%;
        position: absolute;
        z-index: 5;
        left: 0;
        right: 0;
        top: 46px;
        max-height: 250px;
        overflow-y: auto;
        color: #9194a4;
        li{
          padding: 15px;
        }
      }
      .phone{
        width: 360px!important;
        border-left: none;
      }
      .check{
        width: auto;
        height: auto;
        min-height: auto;
        padding: 0;
      }
      > .title {
        font-size: 30px;
      }
      > .tab {
        margin: 10px 0 20px;
        span {
          margin: 0 20px;
          padding-bottom: 5px;
          cursor: pointer;
        }
      }
      .active {
        color: #7a98f7;
        border-bottom: 2px solid #7a98f7;
      }
      .code-box {
        width: 520px;
        height: 46px;
        input {
          border: none;
          height: 44px;
          min-height: 44px;
          width: 420px;
        }
      }
    }
    .right-box{
      margin-left: 100px;
      .right-tip{
        color: #61688a;
        margin-top: 120px;
        p{
          margin-top: 20px;
        }
      }
    }
  }
  button {
    border: none;
    line-height: 43px;
    width: 93px;
    color: #c7cce6;
    background: #1e2235;
    cursor: pointer;
  }
  .reg-btn,
  .confirm-btn {
    line-height: 46px;
    width: 200px;
    margin: 20px 0 0;
    border: none;
    background: #7a98f7;
    color: #fff;
    cursor: pointer;
  }
}
</style>